// components
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface AdminInviteSentPageProps {
  onBack: () => void;
  firstName: string;
  lastName: string;
  email: string;
  organizationName: string;
  onInviteAnother: () => void;
  onDone: () => void;
}

export const AdminInviteSentPage = ({
  onBack,
  firstName,
  lastName,
  email,
  organizationName,
  onInviteAnother,
  onDone,
}: AdminInviteSentPageProps) => {
  return (
    <ModalPageTemplate onBack={onBack}>
      <CenterPageTemplate>
        <FloatingContent
          title={`Invitation Sent to ${firstName} ${lastName}`}
          description={`A magic link has been sent to ${email}. They'll be able to join ${organizationName} and manage referrals.`}
          actions={[
            {
              label: 'Invite Another Admin',
              variant: 'primary',
              onClick: onInviteAnother,
            },
            {
              label: 'Back To Dashboard',
              variant: 'secondary',
              onClick: onDone,
            },
          ]}
        />
      </CenterPageTemplate>
    </ModalPageTemplate>
  );
};

AdminInviteSentPage.displayName = 'AdminInviteSentPage';
export default AdminInviteSentPage;
